import {deepClone} from "@/utils/index";
import Vue from "vue";
import {timeStampToDate, numberFormat} from "@/utils/index";

/**
 *  中间页
 */
export const persistentData = {
  namespaced: true,
  state: {
    dataMap: {},// key:page相关页面url
  },
  getters: {
    getDataWithPage: state => page => {
      return state.dataMap[page] || null;
    },
  },
  mutations: {
    setData(state, {page, data}) {
      if (state.dataMap[page]) {
        for (let key in data) {
          Vue.set(state.dataMap[page], key, data[key]);
        }

      } else {
        Vue.set(state.dataMap, page, data);
      }
    },
    //删除某页的某个数据
    deleteOneDataToPage(state, {page, dataName}) {
      if (state.dataMap[page]) {
        Vue.delete(state.dataMap[page], dataName);
      }
    },
    cleanAllDataWithPage(state, page) {
      Vue.set(state.dataMap, page, null);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/middleware/persistentData.js